export function setOrderUnitsCookie(
  counts: Record<string, number> | number | null,
  days = 7,
  domain = ".solarcloud.com.au"
) {
  if (counts === null || counts === undefined) return;
  try {
    const name = "order_units";
    const value = encodeURIComponent(JSON.stringify(counts));
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    const domainAttr =
      host === "localhost" || host === "127.0.0.1" || host === "::1" ? "" : `; Domain=${domain}`;

    // Use SameSite=None and Secure to allow cross-site usage when served over HTTPS.
    const secureAttr = "; SameSite=None; Secure";

    document.cookie = `${name}=${value}; Expires=${expires}; Path=/` + domainAttr + secureAttr;
  } catch (e) {
    // swallow errors in cookie write
    // eslint-disable-next-line no-console
    console.error("Failed to write order_units cookie", e);
  }
}

export function getOrderUnitsCookie() {
  const name = "order_units";
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[1]));
  } catch (e) {
    return null;
  }
}
